import React, {  useState } from 'react';
import { Layout } from './components/Layout';
import AuthContext from './AuthContext'
import { PleaseDoAtAppInitializationComponent } from './PleaseDoAtAppInitialization'
import './custom.css';
import { LoginComponent } from "./components/Login"
import "primereact/resources/themes/lara-light-indigo/theme.css";
import 'primereact/resources/primereact.css';                       
import 'primeicons/primeicons.css';                                 
import { RoutesComponent } from './Routes';
import { ToastComponent } from './Toast';
import ToastContext from './ToastContext';
import ToastConnectionContext from './ToastConnectionContext';
import { isUserAuthentificated } from './auth'

export const App = () => {
    const [authUser, setAuthUser] = useState();
    const [toast, setToast] = useState([]);
    const [signalRConnection, setSignalRConnection] = useState();

    let loggin = <></>
    if (!isUserAuthentificated(authUser)) {
        loggin = <LoginComponent></LoginComponent>
    }
    else {
        loggin = <RoutesComponent></RoutesComponent>
    }

    return <AuthContext.Provider value={{ authUser, setAuthUser }} >
        <ToastContext.Provider value={{ toast, setToast }}>
        <ToastConnectionContext.Provider value={{ signalRConnection, setSignalRConnection } }>
        <PleaseDoAtAppInitializationComponent />
            <Layout>
            <ToastComponent/>
            {loggin }
                </Layout>
         </ToastConnectionContext.Provider>
        </ToastContext.Provider>
        </AuthContext.Provider>
};
